import { ApiResponse } from 'interfaces/api-response';
import { getBaseHeaderApi } from '../services/apiHelper';
import { adminApi } from '../services/services';

export const adminLeaveConfigApi = adminApi.injectEndpoints({
    endpoints(builder) {
        return {
            getLeaveConfigApi: builder.query<
                ApiResponse<{
                    leave_cut_off_date: string;
                }>,
                void
            >({
                query: () => ({
                    url: '/leave-config',
                    method: 'GET',
                    headers: getBaseHeaderApi()
                })
            }),
            updateLeaveConfigApi: builder.mutation<ApiResponse<unknown>, { leave_cut_off_date: string }>({
                query: (body) => ({
                    url: '/leave-config/9f32f86c-67d1-40e2-8d46-119c24ed1b7b',
                    method: 'PATCH',
                    data: body,
                    headers: getBaseHeaderApi()
                })
            })
        };
    }
});

export const { useGetLeaveConfigApiQuery, useUpdateLeaveConfigApiMutation } = adminLeaveConfigApi;
